import { Injectable } from '@angular/core';
import { Cupom } from '@domain/dto/reserva/reserva-cupom-get.dto';
import { Reserva } from '@domain/dto/reserva/reserva-post.dto';
import { Protecao, ServicoAdicional, Tarifa, Taxa, Vehicle } from '@domain/dto/vehicle/vehicle-get.dto';

const reservasKey = 'reservaData';
const homeKey = 'homeData';
const vehicleKey = 'vehicleData';
const vehiclesKey = 'vehiclesData';
const tariffKey = 'tariffData';
const protectionKey = 'protectionData';
const additionalsKey = 'additionalsData';
const taxasKey = 'taxasData';
const maxStepAllowedKey = 'maxStepAllowed';
const cupomKey = 'cupomData';
const personalData = 'personalData';

@Injectable({
  providedIn: 'root',
})
export class ReservaService {
  private reservas!: Reserva;
  private userDados: any;
  private home!: any;
  public vehicle!: Vehicle;
  private vehicles!: Vehicle[];
  private tariff!: Tarifa;
  private protection!: Protecao;
  private additionals!: ServicoAdicional[];
  private taxas!: Taxa[];
  private cupom!: Cupom | null;
  private maxStep: string = '0';
  taxaAdministrativa = 0;

  constructor() {}

  get reservasData(): Reserva {
    const reservas = sessionStorage.getItem(reservasKey) || localStorage.getItem(reservasKey);
    if (reservas) this.reservas = JSON.parse(reservas);
    return this.reservas;
  }

  set reservasData(reservas: Reserva) {
    if (reservas) {
      localStorage.setItem(reservasKey, JSON.stringify(reservas));
    }
  }


  get homeData() {
    const home = sessionStorage.getItem(homeKey) || localStorage.getItem(homeKey);
    if (home) this.home = JSON.parse(home);
    return this.home;
  }

  set homeData(homeData: any) {
    if (homeData) {
      localStorage.setItem(homeKey, JSON.stringify(homeData));
    }
  }

  get vehicleData() {
    const vehicle = sessionStorage.getItem(vehicleKey) || localStorage.getItem(vehicleKey);
    if (vehicle) this.vehicle = JSON.parse(vehicle);
    return this.vehicle;
  }

  set vehicleData(vehicleData: any) {
    if (vehicleData) {
      localStorage.setItem(vehicleKey, JSON.stringify(vehicleData));
    }
  }

  get vehiclesData() {
    const vehicles = sessionStorage.getItem(vehiclesKey) || localStorage.getItem(vehiclesKey);
    if (vehicles) this.vehicles = JSON.parse(vehicles);
    return this.vehicles;
  }

  set vehiclesData(vehiclesData: any) {
    if (vehiclesData) {
      localStorage.setItem(vehiclesKey, JSON.stringify(vehiclesData));
    }
  }

  get tariffData() {
    const tariff = sessionStorage.getItem(tariffKey) || localStorage.getItem(tariffKey);
    if (tariff) this.tariff = JSON.parse(tariff);
    return this.tariff;
  }

  set tariffData(tariffData: any) {
    if (tariffData) {
      localStorage.setItem(tariffKey, JSON.stringify(tariffData));
    }
  }

  get protectionData() {
    const protection = sessionStorage.getItem(protectionKey) || localStorage.getItem(protectionKey);
    if (protection) this.protection = JSON.parse(protection);
    return this.protection;
  }

  set protectionData(protectionData: any) {
    if (protectionData) {
      localStorage.setItem(protectionKey, JSON.stringify(protectionData));
    }
  }

  get additionalsData() {
    const additionals =
      sessionStorage.getItem(additionalsKey) || localStorage.getItem(additionalsKey);
    if (additionals) this.additionals = JSON.parse(additionals);
    return this.additionals;
  }

  set additionalsData(additionalsData: any) {
    if (additionalsData) {
      localStorage.setItem(additionalsKey, JSON.stringify(additionalsData));
    }
  }

  get taxasData() {
    const taxas =
      sessionStorage.getItem(taxasKey) || localStorage.getItem(taxasKey);
    if (taxas) this.taxas = JSON.parse(taxas);
    return this.taxas;
  }

  set taxasData(taxasData: any) {
    if (taxasData) {
      localStorage.setItem(taxasKey, JSON.stringify(taxasData));
    }
  }

  get maxStepAllowed() {
    const step =
      sessionStorage.getItem(maxStepAllowedKey) || localStorage.getItem(maxStepAllowedKey);
    if (step) this.maxStep = JSON.parse(step);
    return this.maxStep;
  }

  set maxStepAllowed(step: string) {
    if (step) {
      localStorage.setItem(maxStepAllowedKey, JSON.stringify(step));
    }
  }

  get cupomData() {
    const cupom = sessionStorage.getItem(cupomKey) || localStorage.getItem(cupomKey);
    if (cupom) this.cupom = JSON.parse(cupom);
    return this.cupom;
  }

  set cupomData(cupom: Cupom | null) {
    if (cupom) {
      localStorage.setItem(cupomKey, JSON.stringify(cupom));
    }
  }

  async clearProtectionsTariffAndAdditionalsData() {
    this.tariffData = {};
    this.protectionData = {};
    this.additionalsData = {};
  }

  clearCupom() {
    this.cupom = null;
    localStorage.removeItem(cupomKey);
  }

  clear() {
    localStorage.removeItem(reservasKey);
    localStorage.removeItem(homeKey);
    localStorage.removeItem(vehicleKey);
    localStorage.removeItem(vehiclesKey);
    localStorage.removeItem(tariffKey);
    localStorage.removeItem(protectionKey);
    localStorage.removeItem(additionalsKey);
    localStorage.removeItem(taxasKey);
    localStorage.removeItem(maxStepAllowedKey);
    sessionStorage.removeItem('reservaPostPayload')
    sessionStorage.removeItem('summaryDataPayment')
    sessionStorage.removeItem('extraHours')
    localStorage.removeItem('personData')
  }
}
